// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-scroll-area-scrollbar {
  display: flex;
  /* ensures no selection */
  -webkit-user-select: none;
          user-select: none;
  /* disable browser handling of all panning and zooming gestures on touch devices */
  touch-action: none;
}
.n-scroll-area-scrollbar[data-orientation="vertical"] {
  width: 10px;
}
.n-scroll-area-scrollbar[data-orientation="horizontal"] {
  flex-direction: column;
  height: 10px;
}
.n-scroll-area-scrollbar::before {
  content: "";
  position: absolute;
  background: var(--color-scrollbar-track);
}
.n-scroll-area-scrollbar[data-orientation="vertical"]::before {
  top: 0;
  right: 0;
  bottom: 0;
  width: 6px;
  height: 100%;
}
.n-scroll-area-scrollbar[data-orientation="horizontal"]::before {
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 6px;
}
.n-scroll-area-scrollbar[data-orientation="vertical"]::after {
  top: 0;
  right: 0;
  bottom: 0;
  margin-right: 2px;
  width: 2px;
  height: 100%;
}
.n-scroll-area-scrollbar[data-orientation="horizontal"]::after {
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 2px;
  width: 100%;
  height: 2px;
}
.n-scroll-area-scrollbar::after {
  content: "";
  position: absolute;
  border-radius: 10px;
  background: var(--color-scrollbar-thumb);
  transition-property: background, opacity;
  transition-duration: 160ms;
  transition-timing-function: ease-out;
  opacity: 0.6;
}
.n-scroll-area-scrollbar:hover::after {
  opacity: 1;
}
.n-scroll-area-scrollbar__thumb {
  flex: 1;
  position: relative;
  z-index: 1;
  /* increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html */
}
.n-scroll-area-scrollbar__thumb::after {
  content: "";
  position: absolute;
  background: var(--color-scrollbar-thumb);
  border-radius: 10px;
}
.n-scroll-area-scrollbar[data-orientation="vertical"] > .n-scroll-area-scrollbar__thumb::after {
  top: 0;
  right: 0;
  bottom: 0;
  margin-right: 2px;
  width: 2px;
  height: 100%;
}
.n-scroll-area-scrollbar[data-orientation="horizontal"] > .n-scroll-area-scrollbar__thumb::after {
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 2px;
  width: 100%;
  height: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/scroll-area/ScrollAreaScrollbar.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,aAAA;EASA,yBAAyB;EAPzB,yBAAA;UAAA,iBAAA;EASA,kFAAkF;EAPlF,kBAAA;AASF;AAPE;EACE,WAAA;AASJ;AANE;EACE,sBAAA;EACA,YAAA;AAQJ;AALE;EACE,WAAA;EACA,kBAAA;EACA,wCAAA;AAOJ;AAJE;EACE,MAAA;EACA,QAAA;EACA,SAAA;EAEA,UAAA;EACA,YAAA;AAKJ;AAFE;EACE,OAAA;EACA,QAAA;EACA,SAAA;EAEA,WAAA;EACA,WAAA;AAGJ;AAAE;EACE,MAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EACA,UAAA;EACA,YAAA;AACJ;AAEE;EACE,OAAA;EACA,QAAA;EACA,SAAA;EAEA,kBAAA;EACA,WAAA;EACA,WAAA;AADJ;AAIE;EACE,WAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,wCAAA;EACA,wCAAA;EACA,0BAAA;EACA,oCAAA;EACA,YAAA;AAJJ;AAOE;EACE,UAAA;AALJ;AAQE;EACE,OAAA;EACA,kBAAA;EAEA,UAAA;EAPF,wGAAwG;AAC1G;AASI;EACE,WAAA;EACA,kBAAA;EAEA,wCAAA;EACA,mBAAA;AARN;AAYE;EACE,MAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EACA,UAAA;EACA,YAAA;AAXJ;AAcE;EACE,OAAA;EACA,QAAA;EACA,SAAA;EAEA,kBAAA;EACA,WAAA;EACA,WAAA;AAbJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.n-scroll-area-scrollbar {\n  display: flex;\n  /* ensures no selection */\n  user-select: none;\n  /* disable browser handling of all panning and zooming gestures on touch devices */\n  touch-action: none;\n\n  &[data-orientation=\"vertical\"] {\n    width: @scroll-area-scrollbar-size;\n  }\n\n  &[data-orientation=\"horizontal\"] {\n    flex-direction: column;\n    height: @scroll-area-scrollbar-size;\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    background: var(--color-scrollbar-track);\n  }\n\n  &[data-orientation=\"vertical\"]::before {\n    top: 0;\n    right: 0;\n    bottom: 0;\n\n    width: 6px;\n    height: 100%;\n  }\n\n  &[data-orientation=\"horizontal\"]::before {\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    width: 100%;\n    height: 6px;\n  }\n\n  &[data-orientation=\"vertical\"]::after {\n    top: 0;\n    right: 0;\n    bottom: 0;\n\n    margin-right: 2px;\n    width: 2px;\n    height: 100%;\n  }\n\n  &[data-orientation=\"horizontal\"]::after {\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    margin-bottom: 2px;\n    width: 100%;\n    height: 2px;\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n\n    border-radius: @scroll-area-scrollbar-size;\n\n    background: var(--color-scrollbar-thumb);\n    transition-property: background, opacity;\n    transition-duration: 160ms;\n    transition-timing-function: ease-out;\n    opacity: 0.6;\n  }\n\n  &:hover::after {\n    opacity: 1;\n  }\n\n  &__thumb {\n    flex: 1;\n    position: relative;\n\n    z-index: 1;\n\n    /* increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html */\n    &::after {\n      content: \"\";\n      position: absolute;\n\n      background: var(--color-scrollbar-thumb);\n      border-radius: @scroll-area-scrollbar-size;\n    }\n  }\n\n  &[data-orientation=\"vertical\"] > &__thumb::after {\n    top: 0;\n    right: 0;\n    bottom: 0;\n\n    margin-right: 2px;\n    width: 2px;\n    height: 100%;\n  }\n\n  &[data-orientation=\"horizontal\"] > &__thumb::after {\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    margin-bottom: 2px;\n    width: 100%;\n    height: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
